// extracted by mini-css-extract-plugin
module.exports = {"mapIframe":"bs-lp20-src-pages-map-module-map-iframe"};